import React from 'react';
import { FaDownload } from 'react-icons/fa';
import Hero from '../../components/Hero/Hero';
import heroBg from '../../assets/images/hero/tspc-banner.png';
import award1 from '../../assets/images/awards/award-1.jpeg';
import award2 from '../../assets/images/awards/award-2.jpeg';
import award3 from '../../assets/images/awards/award-3.jpeg';
import './Awards.css';

const awards = [
  { img: award1, title: 'Company Award' },
  { img: award2, title: 'Company Award' },
  { img: award3, title: 'Company Award' },
];

const certificates = [
  { name: 'ISO 14001 Environmental Management Certificate', type: 'Environmental Management' },
  { name: 'ISO 9001 Quality Management Certificate', type: 'Quality Management' },
];

const Awards = () => (
  <div>
    <Hero title={<>Awards & <span className="highlight">Certificates</span></>} subtitle="Recognition of our commitment to quality manufacturing and environmental responsibility." backgroundImage={heroBg} />

    <section className="awards section">
      <div className="container">
        <p className="section-label">Recognition</p>
        <h2 className="section-title">Our <span className="highlight">Awards</span></h2>
        <div className="awards__grid">
          {awards.map((a, i) => (
            <div className="awards__item" key={i}>
              <img src={a.img} alt={a.title} />
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="certificates section">
      <div className="container">
        <p className="section-label">ISO Certified</p>
        <h2 className="section-title">Our <span className="highlight">Certificates</span></h2>
        <div className="certificates__grid">
          {certificates.map((c, i) => (
            <div className="certificate-card" key={i}>
              <div className="certificate-card__badge">{c.type === 'Environmental Management' ? '14001' : '9001'}</div>
              <h3>{c.type}</h3>
              <p>{c.name}</p>
              <button className="btn btn-outline" disabled>
                <FaDownload /> Download PDF
              </button>
              <span className="certificate-card__note">PDF available upon request</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default Awards;
